import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import SmartWHTransfer from 'components/Sales/Smart/WarehouseTransfer';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';
import { getWarehouseCodeFromCache } from 'utils';

export default function SmartWHT(): JSX.Element {
  return (
    <ContentLayout 
      titleKey="titles.whtransfer" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
    >
      {<SmartWHTransfer />}
    </ContentLayout>
  );
}
